// Touring Collection — entertainer/touring coach imagery.
//
// Iteration 89 image reliability repair:
//   The IMG_564x range originally referenced here (dkozs0mc, bt36n67d,
//   80qlg94d, g50mf7qn, mow8b2fv) was never committed to
//   /app/frontend/public/assets/coach-photos and therefore served the
//   SPA HTML fallback (200 text/html) in both Preview and Production —
//   the browser rendered them as broken images.  We remap the
//   collection to on-disk EXTERIOR photos of a similar visual
//   character.  Filenames are preserved elsewhere where they exist,
//   so no functional signature changes.
import { _ASSET_BASE } from "./_base";

export const TOURING_PHOTOS = [
  `${_ASSET_BASE}/f293owpn_IMG_5542.webp`, // Prevost X3-45 aspens fall (HD) — hero
  `${_ASSET_BASE}/q7uje42u_IMG_5548.jpeg`, // dark grey Prevost w/ awning, palms
  `${_ASSET_BASE}/pd1l0vwe_IMG_5543.webp`, // motorcoach resort rows (HD)
  `${_ASSET_BASE}/9t0k4o43_IMG_5620.jpeg`, // Prevost side profile
  `${_ASSET_BASE}/j5i0c0g7_IMG_5547.jpeg`, // black Prevost X3-45, palms
];

const touring = {
  hero: `${_ASSET_BASE}/f293owpn_IMG_5542.webp`,   // Prevost X3-45 aspens fall
  accent: `${_ASSET_BASE}/q7uje42u_IMG_5548.jpeg`, // dark grey Prevost w/ awning
  gallery: [
    `${_ASSET_BASE}/pd1l0vwe_IMG_5543.webp`,       // motorcoach resort rows
    `${_ASSET_BASE}/9t0k4o43_IMG_5620.jpeg`,       // Prevost side profile
    `${_ASSET_BASE}/j5i0c0g7_IMG_5547.jpeg`,       // black Prevost X3-45
  ],
  card: `${_ASSET_BASE}/f293owpn_IMG_5542.webp`,
  social: `${_ASSET_BASE}/f293owpn_IMG_5542.webp`,
};
export default touring;
